import { Icon } from 'iconsax-reactjs';
import React from 'react';

export const Background: Icon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.54462 16.918C4.71348 17.9163 6.47588 17.9163 10.0007 17.9163C13.5254 17.9163 15.2878 17.9163 16.4567 16.918C16.6227 16.7763 16.7772 16.6217 16.919 16.4557C17.9173 15.2868 17.9173 13.5244 17.9173 9.99967C17.9173 6.4749 17.9173 4.71251 16.919 3.54364C16.7772 3.37766 16.6227 3.22307 16.4567 3.08132C15.2878 2.08301 13.5254 2.08301 10.0007 2.08301C6.47588 2.08301 4.71348 2.08301 3.54462 3.08132C3.37863 3.22307 3.22405 3.37766 3.08229 3.54364C2.08398 4.71251 2.08398 6.4749 2.08398 9.99967C2.08398 13.5244 2.08398 15.2868 3.08229 16.4557C3.22405 16.6217 3.37863 16.7763 3.54462 16.918Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.33398 16.6663L16.6673 3.33301"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.24805 13.1683L13.1712 2.24512"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.7551 6.82812L6.83203 17.7513"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.25 17.9167L17.9167 11.25"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.08398 8.74967L8.75065 2.08301"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
